 const InitialData = {
    error: false, 
    msg: '',
    isLoggedIn : false,
    userTokenData : {},
    selectedMenu : 'Home',
    loader: false,
    LoginFormData:{ isLoginForm:false, privacyPolicy:false,marketingoffers:false, offers: false, loyaltyConsent:false, marketingComm:false, error:{}, loginApiError:""},
    HomeData:{rewardsEnrollTermsConditions:false, sscTermsConditions:false,migrationTermsConditions:false,error:{}, homeApiError:{}},
    RedirectLoader : false,
}
export default InitialData